import React from "react";
import {
  DebouncedTextInput,
  Group,
  GroupItem,
  ReferenceSelectInput,
} from "ra-friendsofbabba";
import { get } from "lodash";
import { useFieldLabel } from "ra-friendsofbabba";
import { useFormState } from "react-final-form";

const EquipmentsInput = (props) => {
  const formState = useFormState({ subscription: { values: true } });
  const typeId = get(formState.values, "equipment_type_id", null);
  const fieldLabel = useFieldLabel({ ...props });

  return (
    <Group {...props} wrapper>
      <Group>
        <GroupItem lg={6}>
          <ReferenceSelectInput reference="equipment-types" optionText="name" />
        </GroupItem>
      </Group>

      {typeId === 4 && (
        <Group>
          <GroupItem lg={6}>
            <DebouncedTextInput
              source="equipment_type_other"
              helperText={`resources.executive-project-equipments.field.other.help`}
              label={fieldLabel("equipment_type_other")}
            />
          </GroupItem>
        </Group>
      )}
    </Group>
  );
};
export default EquipmentsInput;
